module.exports = __webpack_public_path__ + "static/media/flightgift.76c16f88.svg";